import { QueryClient } from '@tanstack/react-query'
import { createTuyau } from '@tuyau/core/client'
import { createTuyauReactQueryClient } from '@tuyau/react-query'

import { registry } from '../../.adonisjs/client/registry'

export const tuyau = createTuyau({
  baseUrl: '/',
  registry,
})

export const urlFor = tuyau.urlFor

export const queryClient = new QueryClient()
export const api = createTuyauReactQueryClient({ client: tuyau })
